import store from '../store/store';
import { mutator } from 'satcheljs';
import { onShowCalendarSharingPermissionsDialog } from 'owa-calendar-sharing';

export default mutator(onShowCalendarSharingPermissionsDialog, msg => {
    store.moduleCommand = 'Open_SharingPermissionsDialog';
});
